module.exports = __webpack_public_path__ + "mo/img/04_Brand-Identity.3e1a653c.png";